import { Component, OnDestroy, OnInit } from "@angular/core";
import { UntypedFormControl } from "@angular/forms";
import {
  filter,
  interval,
  map,
  Subject,
  Subscription,
  take,
  takeUntil,
} from "rxjs";
import {
  CloudTypes,
  Entities,
  HpcVMStates,
  ImportCSVType,
  NodeTypes,
} from "src/app/core/models/globals";
import {
  DetachNodeAction,
  MultiNodeActionDTO,
  Node,
  NodeAction,
} from "src/app/core/models/node";
import { ConfirmDialogComponent } from "src/app/modules/shared/components/confirm-dialog/confirm-dialog.component";
import { NodeNetwork } from "../../../../core/models/nodeNetwork";
import { UserRoleNames } from "../../../../core/models/users";
import { AddNodeComponent } from "../../modals/add-node/add-node.component";
import { AttachDeploymentComponent } from "../../modals/attach-deployment/attach-deployment.component";
import { DetachNodesComponent } from "../../modals/detach-nodes/detach-nodes.component";
import { EditColoumsComponent } from "../../modals/edit-coloums/edit-coloums.component";
import { ImportNodesComponent } from "../../modals/import-nodes/import-nodes.component";
import { NodeReportsComponent } from "../../modals/node-reports/node-reports.component";
import { NodeactionConfirmComponent } from "../../modals/nodeaction-confirm/nodeaction-confirm.component";
import { UpdateNodeComponent } from "../../modals/update-node/update-node.component";
import { NodeListComponent } from "../node-list/node-list.component";

@Component({
  selector: "app-all-nodes-list",
  templateUrl: "./all-nodes-list.component.html",
  styleUrls: [
    "./all-nodes-list.component.scss",
    "../node-list/node-list.component.scss",
  ],
})
export class AllNodesListComponent
  extends NodeListComponent
  implements OnInit, OnDestroy {
  columnInfo: {
    columnsOfComponents: string[];
    coloumToShow: string[];
  };
  p: number = 1;
  allNodesSearchText: string = "";
  filterNodes: Node[];
  coloumToShow: string[] = [];
  columnsOfComponents: string[] = [];
  allNodeReloadSub: Subscription;
  entries: number;
  nodeCount: number;
  startRange: number = 1;
  nodeEntries: number[] = [];
  nodesNumberToShow: number = 20;
  entriesNumber: number = 20;
  showAllEntries: boolean = false;
  paginationButtonText: string = `Show All Entries`;
  cpuSort: boolean = false; // sort
  ramSort: boolean = false; // sort
  gpuSort: boolean = false; // sort
  gpuMemorySort: boolean = false; // sort
  vmInfoes: DetachNodeAction[];
  nodeNetwork: NodeNetwork = {
    name: "",
    privateIp: "fetching...",
    publicIp: "fetching...",
    ipType: "fetching...",
    dns: "fetching...",
    macAddress: "fetching...",
    gatewayName: "fetching...",
    NewMachineName: "",
  };
  granularityValue = "One Day";
  dateFilterValue = "7";
  allNodeAvailabilityList: string[] = [];
  avlDeploymentsForFilter: string[] = [];
  deps: string[] = [];
  isMonitor: boolean =
    this.authenticationService.currentUserValue.role == UserRoleNames.Reader
      ? true
      : false;
  destroy$ = new Subject<void>();

  ngOnInit(): void {
    this.columnInfo = {
      columnsOfComponents: [],
      coloumToShow: [],
    };
    //this.checkDashboardRedirectSort();
    this.vmStates = this.vmStates.filter(
      (e) => e != HpcVMStates.STATE_CODE_STOPING
    );
    //this.columnInfo.columnsOfComponents = ["Node Type", "Avalability", "State", "GPU Mem %", "GPU %", "Sessions", "CPU %", "Os-Platform"]
    this.createLocalStorage();
    this.nodeService
      .getAllNodeCount(this.authenticationService.currentUserValue.username)
      .pipe(takeUntil(this.destroy$))
      .subscribe((data) => {
        this.nodeCount = Number(data);
        if (this.nodeCount < 100) {
          this.nodeEntries.push(this.nodeCount);
        } else {
          for (let i = 1; i <= this.nodeCount / 100; i++) {
            if (this.nodeCount / 100 != 0) {
              this.nodeEntries.push(i * 100);
            }
          }
          this.nodeEntries.push(this.nodeCount);
        }
        this.entries = this.nodeEntries[0];
        this.spinner.show("allNodesList");
        this.loadAllNodesListByRange(this.entries);
        this.startDataReloadSub();
      });
    this.nodeService
      .getWSDeployments()
      .pipe(takeUntil(this.destroy$))
      .subscribe((data) => {
        this.vmInfoes = <DetachNodeAction[]>JSON.parse(JSON.stringify(data));
      });
    this.checkDashboardRedirectSort();
    this.getColumnSetting();
    this.navService.sendParentData(Entities.Nodes);
    this.nodeService.sendNodeAction
      .pipe(
        takeUntil(this.destroy$),
        filter((x) => x != null)
      )
      .subscribe((action) => {
        this.nodeAction(action.action, action.node);
      });
  }

  ngOnDestroy(): void {
    //Called once, before the instance is destroyed.
    //Add 'implements OnDestroy' to the class.
    this.allNodeReloadSub?.unsubscribe();
    this.nodeService.dashboardRedirectSort = null;
    this.destroy$.next();
    this.destroy$.complete();
  }

  toggleFilters() {
    this.toShowFilter = !this.toShowFilter;
  }

  openAddNodeDialog() {
    const dialogRef = this.dialog.open(AddNodeComponent, {
      width: "40vw",
      disableClose: true,
      autoFocus: false,
      data: {
        depName: null,
        cloudType: this.cloudType,
        nodeList: this.nodes,
      },
    });
    dialogRef.afterClosed().subscribe((response) => {
      if (response) {
        this.loadAllNodesList();
        this.refreshComponent();
      }
    });
  }
  sortAvailability(toggle) {
    if (toggle) {
      this.availabilitySort = !this.availabilitySort;
    }
    this.activeSort = "availability";

    // Reset other sorts
    this.cpuSort = false;
    this.ramSort = false;
    this.gpuSort = false;
    this.gpuMemorySort = false;

    if (this.availabilitySort) {
      // Ascending - alphabetical order (A to Z)
      this.nodes = this.nodes.sort((a, b) => {
        const aVal = a.availability ? a.availability : "NA";
        const bVal = b.availability ? b.availability : "NA";
        return aVal.localeCompare(bVal);
      });
    } else {
      // Descending - reverse alphabetical order (Z to A)
      this.nodes = this.nodes.sort((a, b) => {
        const aVal = a.availability ? a.availability : "NA";
        const bVal = b.availability ? b.availability : "NA";
        return bVal.localeCompare(aVal);
      });
    }
  }
  async nodeAction(action: NodeAction, node: Node) {
    if (
      node.nodeType == NodeTypes.TxtHeadNode ||
      node.nodeType == NodeTypes.TxtHead_Workstore ||
      node.nodeType == NodeTypes.TxtHead_Compute_Workstore
    ) {
      this.headAndComputeNodeActive = this.checkStateOfNodes();
    } else {
      this.headAndComputeNodeActive = false;
    }
    if (action.value == 3 || action.value == 4) {
      if (
        node.state != HpcVMStates.STATE_CODE_STARTED &&
        node.state != HpcVMStates.STATE_CODE_UPDATING
      ) {
        this.snackBar.open("Node is not in active state.", "Ok", {
          duration: 5000,
        });
        return;
      }
    }

    if (action.value == 1) {
      if (
        node.state == HpcVMStates.STATE_CODE_STOPING_CANCEL_WAIT ||
        node.state == HpcVMStates.STATE_CODE_STOPING
      ) {
        this.forcefully = true;
        this.message =
          "Node is in " +
          node.state +
          " Do you still want to " +
          action.name +
          " the Node, Forcefully!?";
      } else {
        this.forcefully = false;
        this.message = "Do you want to " + action.name + " the Node?";
      }
    }

    if (action.value == 3) {
      this.message = "Do you want to " + action.name + " the Node?";
    }

    if (action.value == 2) {
      if (
        node.state == HpcVMStates.STATE_CODE_STARTING ||
        HpcVMStates.STATE_CODE_PRESTARTED
      ) {
        this.forcefully = true;
        this.message =
          "Node is in " +
          node.state +
          " Do you still want to " +
          action.name +
          " the Node, Forcefully!?";
      }
      if (
        node.state == HpcVMStates.STATE_CODE_STARTED ||
        node.state == HpcVMStates.STATE_CODE_ACTIVE_OFFLINE ||
        node.state == HpcVMStates.STATE_CODE_STOPPED_DEALLOC ||
        node.state == HpcVMStates.STATE_CODE_STOPING ||
        node.state == HpcVMStates.STATE_CODE_STOPING_CANCEL_WAIT
      ) {
        this.forcefully = false;
        this.message = "Do you want to " + action.name + " the Node?";
      }
    }

    let sharedData = {
      node: node.vmName,
      deployment: node.depName,
      actionName: action.name,
      actionVal: action.value,
      message: this.message,
      platform: node.vmPlatform,
      showWarning: this.headAndComputeNodeActive,
      forcefully: this.forcefully,
    };
    switch (true) {
      case [1, 2, 3, 4].includes(action.value):
        const dialogRef = this.dialog.open(NodeactionConfirmComponent, {
          disableClose: true,
          width: "400px",
          data: sharedData,
        });
        dialogRef.afterClosed().subscribe((res) => {
          this.headAndComputeNodeActive = false;
          if (res) {
            setTimeout(() => {
              this.loadAllNodesList();
            }, 1000);
          }
        });
        break;
      case action.value == 5:
        let depNamesAttachedtoNodes = this.nodes
          .filter((vm) => vm.vmName == node.vmName)
          .map((node) => node.depName);
        this.dialog
          .open(AttachDeploymentComponent, {
            disableClose: true,
            width: "400px",
            data: {
              wsName: [node.vmName],
              depNames: depNamesAttachedtoNodes,
              cloudProvider: node.connectorType,
            },
          })
          .afterClosed()
          .subscribe((res) => {
            if (res) {
              this.snackBar.open("Action is in progress.", "Ok", {
                duration: 5000,
              });
              this.nodeService
                .triggerNodeAction(
                  node.vmName,
                  res,
                  action.value.toString(),
                  node.vmPlatform,
                  this.forcefully,
                  false,
                  node.nodeType,
                  false
                )
                .subscribe({
                  next: (data: any) => {
                    this.snackBar.open(data.body?.actionMessage, "Ok", {
                      duration: 5000,
                    });
                    this.loadAllNodesList();
                    this.refreshComponent();
                  },
                  error: (err) => {
                    this.snackBar.open(err.error?.actionMessage, "Ok", {
                      duration: 5000,
                    });
                  },
                });
            }
          });
        break;
      case action.value == 6:
        this.dialog
          .open(ConfirmDialogComponent, {
            autoFocus: false,
            disableClose: false,
            width: "25%",
            data: {
              titleMessage: "Detach Workstation",
              bodyMessage: `Do you want to detach following workstations ${node.vmName}.`,
              cancelText: "Cancel",
              submitText: "Proceed",
            },
          })
          .afterClosed()
          .subscribe((res) => {
            if (res) {
              this.snackBar.open("Action is in progress.", "Ok", {
                duration: 5000,
              });
              this.nodeService
                .triggerNodeAction(
                  node.vmName,
                  node.depName,
                  action.value.toString(),
                  node.vmPlatform,
                  this.forcefully,
                  false,
                  node.nodeType,
                  false
                )
                .subscribe({
                  next: (data: any) => {
                    this.snackBar.open(data.body?.actionMessage, "Ok", {
                      duration: 5000,
                    });
                    this.loadAllNodesList();
                    this.refreshComponent();
                  },
                  error: (err) => {
                    this.snackBar.open(err.error?.actionMessage, "Ok", {
                      duration: 5000,
                    });
                  },
                });
            }
          });
        break;
      case action.value == 7:
        this.removeSession(node);
        break;
      case action.value == 8:
        this.dialog.open(NodeReportsComponent, {
          width: "70vw",
          height: "55vh",
          data: { depName: node.depName, wsName: node.vmName },
        });
        break;
      case action.value == 9:
        this.openTerminal(node);
        break;
      case action.value == 10:
        //this.getNetworkInfo();
        this.nodeService
          .getNodeNetworkInfo(this.selectedNode.vmName)
          .pipe(takeUntil(this.destroy$))
          .subscribe({
            next: (data) => {
              this.nodeNetwork = JSON.parse(JSON.stringify(data));
              const dialogRefUpdate = this.dialog.open(UpdateNodeComponent, {
                autoFocus: false,
                disableClose: true,
                width: "25%",
                data: {
                  nodeInfo: this.selectedNode,
                  nodeNetwork: this.nodeNetwork,
                  depName: !this.selectedNode.depName
                    ? this.selectedNode.allDeploymentsList
                    : this.selectedNode.depName,
                },
              });
              dialogRefUpdate.afterClosed().subscribe((res) => {
                if (res) this.refreshComponent();
                // this.loadAllNodesList();
              });
            },
            error: (err) => { },
          });
        break;
      case action.value == 11:
        if (node && node.allDeploymentsList && node.allDeploymentsList.split(',').length > 1) {
          this.snackBar.open("Node is attached to multiple deployments, detach it from all deployments to delete.", "Ok", { duration: 5000 });
        }
        this.dialog
          .open(ConfirmDialogComponent, {
            autoFocus: false,
            disableClose: false,
            width: "25%",
            data: {
              titleMessage: "Delete Workstation",
              bodyMessage: `Do you want to delete following workstations ${node.vmName}.`,
              cancelText: "Cancel",
              submitText: "Proceed",
              skipMessage: node.cloudType == CloudTypes.KVM ? "Skip deletion from SyncHpcInfra" : "Skip Cloud Deletion",
            },
          })
          .afterClosed()
          .subscribe((res) => {
            if (res) {
              this.snackBar.open("Action is in progress.", "Ok", {
                duration: 5000,
              });
              const skipCloud = res.skipCloudDeployment;
              this.nodeService
                .triggerNodeAction(
                  node.vmName,
                  node.allDeploymentsList,
                  action.value.toString(),
                  node.vmPlatform,
                  false,
                  false,
                  node.nodeType,
                  skipCloud
                )
                .subscribe({
                  next: (data: any) => {
                    this.snackBar.open(data.body?.actionMessage, "Ok", {
                      duration: 5000,
                    });
                    this.loadAllNodesList();
                    this.refreshComponent();
                  },
                  error: (err) => {
                    this.snackBar.open(err.error?.actionMessage, "Ok", {
                      duration: 5000,
                    });
                  },
                });
            }
          });
        break;
      default:
        break;
    }
    // this.loadAllNodesList();
  }

  applyFilter() {
    //this.allNodeReloadSub?.unsubscribe();
    if (this.activeSort != null || this.activeSort != "") {
      this.applySort(this.activeSort);
    }
    let filteredNodes = this.nodes;
    if (filteredNodes && this.filterDeployment === "All") {
      var uniqueNodes = [];
      filteredNodes?.filter(function (item) {
        var i = uniqueNodes.findIndex((x) => x.vmName == item.vmName);
        if (i <= -1) {
          uniqueNodes.push(item);
        }
        return null;
      });
      filteredNodes = uniqueNodes;
    }

    if (this.nodesSearchText != "") {
      filteredNodes = filteredNodes?.filter((nd) =>
        nd.vmName.toLowerCase().includes(this.nodesSearchText.toLowerCase())
      );
    }
    if (this.filterDeployment !== "All") {
      filteredNodes = filteredNodes?.filter((nd) =>
        nd.allDeploymentsList?.includes(this.filterDeployment)
      );
      filteredNodes = [
        ...new Map(
          filteredNodes.map((item) => [item["vmName"], item])
        ).values(),
      ];
    }
    if (this.filterAvailability != "All") {
      filteredNodes = filteredNodes?.filter(
        (nd) => nd.availability == this.filterAvailability
      );
    }
    if (this.filterNodetypes != "All") {
      filteredNodes = filteredNodes?.filter(
        (nd) => nd.nodeType == this.filterNodetypes
      );
    }
    if (this.filterState != "All") {
      if (this.filterState == "Assigned") {
        filteredNodes = filteredNodes?.filter(
          (nd) => nd.state.toLowerCase() != "unassigned"
        );
        return filteredNodes;
      }
      if (this.filterState == HpcVMStates.STATE_CODE_STOPING_CANCEL_WAIT) {
        filteredNodes = filteredNodes?.filter(
          (nd) =>
            nd.state == HpcVMStates.STATE_CODE_STOPING ||
            nd.state == HpcVMStates.STATE_CODE_STOPING_CANCEL_WAIT
        );
      } else {
        filteredNodes = filteredNodes?.filter(
          (nd) => !nd.state.localeCompare(this.filterState)
        );
      }
    }
    if (this.filterPlatform != "All") {
      filteredNodes = filteredNodes?.filter(
        (nd) => nd.vmPlatform.toLowerCase() == this.filterPlatform.toLowerCase()
      );
    }
    return filteredNodes;
  }

  resetFilter() {
    this.filtersApplied = false;
    this.filterDeployment = "All";
    this.filterNodetypes = "All";
    this.filterState = "All";
    this.filterAvailability = "All";
    this.filterPlatform = "All";
    this.nodesSearchText = "";
    this.filtersApplied = false;
    this.startDataReloadSub();
  }

  async startDataReloadSub() {
    this.allNodeReloadSub = interval(
      this.syncConfig.config.nodes.listReqInterval
    ).subscribe(async () => {
      // await this.loadAllNodesListByRange(this.entries);
    });
  }

  allNodesAction(value) {
    let filteredNodes = this.applyFilter();
    if (this.multiSelectIndex.length == 0) {
      this.snackBar.open("Select node(s)  to perform action", "Ok", {
        duration: 5000,
      });
      this.refreshComponent();
      this.actionValue = "0";
      return;
    }

    let wsObj: MultiNodeActionDTO = {
      attachObj: null,
      detachObj: [],
    };

    let wsNamesObj = filteredNodes
      ?.filter((nd, i) => {
        return (
          this.multiSelectIndex?.includes(nd.vmName) &&
          nd.nodeType == NodeTypes.TxtWorkstation
        );
      })
      .map((nd) => {
        let ws: DetachNodeAction = {
          wsName: nd.vmName,
          deploymentName: nd.depName,
        };
        return ws;
      });
    let wsNames = wsNamesObj.map((ws) => ws.wsName);
    let cloudProvider = this.multiSelectedNodes![0]?.connectorType;

    if (wsNames.length == 0) {
      this.snackBar.open(
        "Only node with type Workstation can perform this action.",
        "Ok",
        { duration: 5000 }
      );
      this.actionValue = "0";
      return;
    }
    switch (Number(value)) {
      case 5:
        this.dialog
          .open(AttachDeploymentComponent, {
            disableClose: true,
            width: "400px",
            data: {
              wsName: wsNames.toString(),
              depNames: [],
              cloudProvider: cloudProvider,
            },
          })
          .afterClosed()
          .subscribe((depNames) => {
            if (depNames) {
              wsObj.attachObj = {
                deploymentNames: depNames,
                wsNames: wsNames.toString(),
              };
              this.nodeService.multiNodeAction(value, wsObj).subscribe({
                next: (data: any) => {
                  this.snackBar.open(
                    data?.actionMessage || data?.body?.actionMessage,
                    "Ok",
                    { duration: 5000 }
                  );
                  this.multiSelectIndex = [];
                  this.loadAllNodesList();
                  this.refreshComponent();
                },
                error: (err) => {
                  this.snackBar.open(err?.error?.actionMessage, "Ok", {
                    duration: 5000,
                  });
                },
              });
            }
            this.actionValue = "0";
          });

        break;

      case 6:
        this.dialog
          .open(ConfirmDialogComponent, {
            autoFocus: false,
            disableClose: false,
            width: "25%",
            data: {
              titleMessage: "Detach Workstation",
              bodyMessage: `Do you want to detach following workstations ${wsNames.toString()}.`,
              cancelText: "Cancel",
              submitText: "Proceed",
            },
          })
          .afterClosed()
          .subscribe((res) => {
            if (res) {
              this.dialog
                .open(DetachNodesComponent, {
                  autoFocus: false,
                  disableClose: false,
                  width: "25%",
                  data: { vmInfoes: this.vmInfoes, workStationNames: wsNames },
                })
                .afterClosed()
                .subscribe((res) => {
                  if (res.status) {
                    this.nodeService
                      .multiNodeAction(value, res.data)
                      .subscribe({
                        next: (data: any) => {
                          this.snackBar.open(
                            data?.actionMessage || data?.body?.actionMessage,
                            "Ok",
                            { duration: 5000 }
                          );
                          this.multiSelectIndex = [];
                          this.loadAllNodesList();
                          this.refreshComponent();
                        },
                        error: (err) => {
                          this.snackBar.open(err.error?.actionMessage, "Ok", {
                            duration: 5000,
                          });
                        },
                      });
                  } else {
                    this.snackBar.open(res?.data, "Ok", { duration: 5000 });
                  }
                });
            }
            this.actionValue = "0";
          });

        break;
      /*case 6:
        wsNames = wsNamesObj.filter(ws => ws.deploymentName != "NA").map(ws => ws.wsName);
        this.dialog.open(ConfirmDialogComponent, {
          autoFocus: false,
          disableClose: false,
          width: '25%',
          data: {
            titleMessage: "Detach Workstation",
            bodyMessage: `Do you want to detach following workstations ${wsNames.toString()}.`,
            cancelText: "Cancel",
            submitText: "Proceed"
          }
        }).afterClosed().subscribe(res => {
          if (res) {
            wsObj.detachObj = wsNamesObj.filter(ws => ws.deploymentName != "NA");
            this.spinner.show("allNodesList")
            this.nodeService.multiNodeAction(value, wsObj).subscribe({
              next: (data: any) => {
                this.snackBar.open(data?.actionMessage || data?.body?.actionMessage, "Ok", { duration: 5000 })
                this.multiSelectIndex = [];
                this.loadAllNodesList();
                this.refreshComponent();
                this.spinner.hide("allNodesList")
              },
              error: (err) => {
                this.snackBar.open(err.error?.actionMessage, "Ok", { duration: 5000 })
              }
            })
          }
        })
        break;*/

      case 11:
        this.dialog
          .open(ConfirmDialogComponent, {
            autoFocus: false,
            disableClose: false,
            width: "25%",
            data: {
              titleMessage: "Delete Workstation",
              bodyMessage: `Do you want to Delete following workstations ${wsNames.toString()}.`,
              cancelText: "Cancel",
              submitText: "Proceed",
            },
          })
          .afterClosed()
          .subscribe((res) => {
            if (res) {
              wsObj.detachObj = wsNamesObj;
              let assignedNames = [];
              let assignedNodes = wsObj.detachObj.filter(
                (el) => el.deploymentName != "NA"
              );
              if (assignedNodes.length > 0) {
                assignedNodes.forEach((el) => assignedNames.push(el.wsName));
              }
              let unAssignedNodes = wsObj.detachObj.filter(
                (el) => el.deploymentName === "NA"
              );
              if (wsObj.detachObj.length > unAssignedNodes.length) {
                this.snackBar.open(
                  `${assignedNames.join(
                    ", "
                  )} these work stations are the part of Deployment, Please detach the work station and then delete. `,
                  "Ok",
                  { duration: 5000 }
                );
                return;
              }
              this.nodeService.multiNodeAction(value, wsObj).subscribe({
                next: (data: any) => {
                  this.snackBar.open(
                    data?.actionMessage || data?.body?.actionMessage,
                    "Ok",
                    { duration: 5000 }
                  );
                  this.multiSelectIndex = [];
                  this.loadAllNodesList();
                  this.refreshComponent();
                },
                error: (err) => {
                  this.snackBar.open(err.error?.actionMessage, "Ok", {
                    duration: 5000,
                  });
                },
              });
            }
            this.actionValue = "0";
          });
        break;

      default:
        break;
    }
  }

  loadAllNodesListByRange(entries) {
    this.spinner.show("allNodesList");
    if (this.entries == 100) {
      this.startRange = 1;
    } else if (this.entries == this.nodeCount) {
      this.startRange = Number(Math.floor(this.nodeCount / 100) * 100) + 1;
    } else {
      this.startRange = Number(this.entries - 100) + 1;
    }
    this.nodeService
      .getAllNodesForUserByRange(entries)
      .pipe(
        map((nodes: any) => {
          nodes.forEach((n) => {
            n.actionsAvl = this.returnActionsAvailableForNodes(n, true);
          });
          return nodes;
        }),
        takeUntil(this.destroy$)
      )
      .subscribe({
        next: (data) => {
          this.nodes = JSON.parse(JSON.stringify(data));
          this.filterNodes = JSON.parse(JSON.stringify(data));
          this.allNodeAvailabilityList = [
            ...new Set([
              ...this.nodes.map((e) =>
                e.availability != null ? e.availability : "NA"
              ),
            ]),
          ].sort();
          if (this.nodes.length != 0) {
            if (!this.selectedNode) {
              this.selectedNode = this.nodes[0];
              this.redirectTo(this.nodes[0], 0);
            }
            this.selectedIndex = this.nodes.findIndex(
              (node) =>
                node.vmName == this.selectedNode.vmName &&
                node.depName == this.selectedNode.depName
            );
            this.nodeService.updateSelectedNode(this.nodes[this.selectedIndex]);
            this.spinner.hide("allNodesList");
            let deploymentList = [
              ...new Set(this.nodes.map((nd) => nd.allDeploymentsList)),
            ];
            deploymentList.forEach((nd) => {
              nd?.split(",").forEach((n) => {
                this.deps.push(n.trim());
              });
            });
            this.avlDeploymentsForFilter = this.deps.filter(function (x, i, a) {
              return a.indexOf(x) === i;
            });
            this.navService.sendLastUpdate(
              this._headerService.getUserNewDate()
            );
            this.applyFilter();
          } else {
            this.spinner.hide("allNodesList");
          }
          this.spinner.hide("allNodesList");
        },
        error: (err) => {
          this.spinner.hide("allNodesList");
        },
      });
  }

  addBulkNodes() {
    const dialogRef = this.dialog.open(ImportNodesComponent, {
      autoFocus: false,
      disableClose: true,
      width: "600px",
      data: {
        importType: ImportCSVType.Nodes,
        requiredParams:
          "MachineName,IpAddress,MacAddress (Optional),GatewayName (Optional),PlatformType (Optional), ConnectorType (Optional)",
        uniqueFields: "ComputerName",
      },
    });
    dialogRef.afterClosed().subscribe((res) => {
      if (res) {
        this.loadAllNodesList();
        this.refreshComponent();
      }
    });
  }

  sortCPU(toggle) {
    if (toggle) {
      this.cpuSort = !this.cpuSort;
    }
    this.activeSort = "cpuUsage";
    this.ramSort = false;
    this.gpuSort = false;
    this.gpuMemorySort = false;
    this.availabilitySort = false;
    //this.filtersApplied = true;
    if (this.cpuSort) {
      this.sortLoadData();
    } else {
      this.nodes = this.nodes?.sort(
        (a, b) => 0 - (b.cpuUsage < a.cpuUsage ? 1 : -1)
      );
    }
  }

  sortRAM(toggle) {
    if (toggle) {
      this.ramSort = !this.ramSort;
    }
    this.activeSort = "ramUsage";
    this.cpuSort = false;
    this.gpuSort = false;
    this.gpuMemorySort = false;
    this.availabilitySort = false;
    if (this.ramSort) {
      this.sortLoadData();
    } else {
      this.nodes = this.nodes?.sort(
        (a, b) => 0 - (b.ramUsage < a.ramUsage ? 1 : -1)
      );
    }
  }

  sortGPU(toggle) {
    if (toggle) {
      this.gpuSort = !this.gpuSort;
    }
    this.activeSort = "gpuUsage";
    this.cpuSort = false;
    this.ramSort = false;
    this.gpuMemorySort = false;
    this.availabilitySort = false;
    if (this.gpuSort) {
      this.sortLoadData();
    } else {
      this.nodes = this.nodes?.sort(
        (a, b) => 0 - (b.gpuUsage < a.gpuUsage ? 1 : -1)
      );
    }
  }

  sortGPUMemory(toggle) {
    if (toggle) {
      this.gpuMemorySort = !this.gpuMemorySort;
    }
    this.activeSort = "gpuMemoryUsage";
    this.cpuSort = false;
    this.ramSort = false;
    this.gpuSort = false;
    this.availabilitySort = false;
    if (this.gpuMemorySort) {
      this.sortLoadData();
    } else {
      this.nodes = this.nodes?.sort(
        (a, b) => 0 - (b.gpuMemoryUsage < a.gpuMemoryUsage ? 1 : -1)
      );
    }
  }

  sortLoadData() {
    if (this.cpuSort) {
      this.nodes = this.nodes?.sort(
        (a, b) => 0 - (b.cpuUsage > a.cpuUsage ? 1 : -1)
      );
    }
    if (this.ramSort) {
      this.nodes = this.nodes?.sort(
        (a, b) => 0 - (b.ramUsage > a.ramUsage ? 1 : -1)
      );
    }
    if (this.gpuSort) {
      this.nodes = this.nodes?.sort(
        (a, b) => 0 - (b.gpuUsage > a.gpuUsage ? 1 : -1)
      );
    }
    if (this.gpuMemorySort) {
      this.nodes = this.nodes?.sort(
        (a, b) => 0 - (b.gpuMemoryUsage > a.gpuMemoryUsage ? 1 : -1)
      );
    }
  }

  resetSortFilter() {
    this.cpuSort = false;
    this.ramSort = false;
    this.gpuSort = false;
    this.gpuMemorySort = false;
    this.filterDeployment = this.depName;
    this.filterNodetypes = "All";
    this.filterState = "All";
    this.filterPlatform = "All";
    this.availabilitySort = false;
  }

  getNetworkInfo() {
    this.nodeService
      .getNodeNetworkInfo(this.selectedNode.vmName)
      .pipe(takeUntil(this.destroy$))
      .subscribe({
        next: (data) => {
          this.nodeNetwork = JSON.parse(JSON.stringify(data));
        },
        error: (err) => { },
      });
  }

  createLocalStorage() {
    let columnInfoObject = JSON.parse(
      localStorage.getItem("allNodeListColoumnsInfo")
    );
    if (!columnInfoObject) {
      this.columnInfo.columnsOfComponents = [
        "Availability",
        "HPC Units",
        "Billed Hrs",
        "State",
        "SchedulerState",
        "Node Group",
        "Alloc/Total",
        "GPU %",
        "GPU Mem %",
        "Network (Mb/sec)",
        "Sessions"
      ];

      this.columnInfo.coloumToShow = [
        "Node Type",
        "Avalability",
        "State",
        "CPU %",
        "RAM %",
      ];
      this.coloumToShow = [...this.columnInfo.coloumToShow];
      localStorage.setItem(
        "allNodeListColoumnsInfo",
        JSON.stringify(this.columnInfo)
      );
    } else {
      this.columnInfo.columnsOfComponents =
        columnInfoObject.columnsOfComponents;
      this.columnInfo.coloumToShow = columnInfoObject.coloumToShow;
      this.coloumToShow = [...this.columnInfo.coloumToShow];
    }
  }

  editColoum() {
    const editColumnDailog = this.dialog.open(EditColoumsComponent, {
      autoFocus: false,
      disableClose: true,
      width: "400px",
      data: {
        columnsFromComponents: [...this.columnInfo.columnsOfComponents],
        previoslySelectedColumns: [...this.columnInfo.coloumToShow],
      },
    });
    editColumnDailog.afterClosed().subscribe((res) => {
      if (res.status) {
        if (res.data != null && res.data.length >= 0) {
          let columsName = res.data.map((el) => el.name);
          let columsNameString = columsName.join(",");
          this.userServices
            .updateUserColumnSetting(
              this.loggedInUser,
              columsNameString,
              this.tableName
            )
            .subscribe((data) => {
              if (data) {
                let response = JSON.parse(JSON.stringify(data));
                if (response.status == 200) {
                  this.nodeListColumnToShow = columsNameString.split(",");
                  this.columnInfo = {
                    ...this.columnInfo,
                    coloumToShow: [...this.nodeListColumnToShow],
                  };
                  this.snackBar.open(response.actionMessage, "Ok", {
                    duration: 5000,
                  });
                } else if (response.status != 200) {
                  this.snackBar.open(response.actionMessage, "Ok", {
                    duration: 5000,
                  });
                }
              }
            });
        }
      }
    });
  }

  onSelectAllCheckBox(event) {
    let filteredNodes = this.applyFilter();
    if (event.target.checked) {
      filteredNodes?.forEach((node, i) => {
        if (!this.multiSelectIndex?.includes(node.vmName)) {
          this.multiSelectIndex.push(node.vmName);
        }
      });
      this.isSelectAll = true;
      if (filteredNodes) {
        this.showAttachSelected = filteredNodes?.every(
          (d) => d.connectorType == filteredNodes![0]?.connectorType
        );
      }
      return;
    } else {
      filteredNodes?.forEach((node, i) => {
        if (this.multiSelectIndex?.includes(node.vmName)) {
          let index = this.multiSelectIndex?.indexOf(node.vmName);
          if (index !== -1) {
            this.multiSelectIndex.splice(index, 1);
          }
        }
      });
      this.showAttachSelected = true;
      if (filteredNodes?.length == this.nodes.length) {
        this.isSelectAll = false;
      }
      return;
    }
  }

  showAllEntriesMethod() {
    if (this.entriesNumber > 0) {
      this.nodesNumberToShow = this.entriesNumber;
      this.p = 1;
    }
  }

  paginationEntries(event) {
    this.entriesNumber = event.target.value;
  }

  /*onSearch() {
    this.filterNodes = [...this.jobsCopy]
    if (this.allNodesSearchText != "") {
      this.filterNodes = this.filterNodes.filter(nd => nd.toLowerCase().includes(this.allNodesSearchText.toLowerCase()) || nd.name.toLowerCase().includes(this.allNodesSearchText.toLowerCase()))
    }
    this.p = 1;
  }
  */

  applySort(sort) {
    if (sort != null || sort != "") {
      switch (sort) {
        case "cpuUsage":
          this.sortCPU(false);
          break;
        case "ramUsage":
          this.sortRAM(false);
          break;
        case "gpuUsage":
          this.sortGPU(false);
          break;
        case "gpuMemoryUsage":
          this.sortGPUMemory(false);
          break;
        default:
          break;
      }
    }
  }

  pageChanged(event) {
    this.p = event;
  }

  async checkDashboardRedirectSort() {
    await new Promise((r) => setTimeout(r, 500));
    let redirectSortVal: string | null = this.nodeService.dashboardRedirectSort;
    if (!redirectSortVal) return;
    if (redirectSortVal.toLowerCase() == "cpu") {
      this.activeSort = "cpuUsage";
      this.cpuSort = false;
    }
    if (redirectSortVal.toLowerCase() == "ram") {
      this.activeSort = "ramUsage";
      this.ramSort = false;
    }
    if (redirectSortVal.toLowerCase() == "gpu") {
      this.activeSort = "gpuUsage";
      this.gpuMemorySort = false;
    }

    if (redirectSortVal.toLowerCase() == "unassigned") {
      this.filterState = "Unassigned";
      this.applyFilter();
    }
    if (redirectSortVal.toLowerCase() == "assigned") {
      this.filterState = "Assigned";
      this.applyFilter();
    }
    this.nodeService.dashboardRedirectSort = null;
  }
}
